// extracted by mini-css-extract-plugin
module.exports = {"isActive":"Link_isActive__riEV3"};